export const REPLACE_COLOR_PANEL_TRANSLATION = {
  REPLACEMENT_LABEL: 'DesignPanel_EditTheme_remove_color_replacement_label',
  REPLACEMENT_BUTTON: 'DesignPanel_EditTheme_remove_color_remove_button',
  HEADER: 'DesignPanel_EditTheme_remove_color_panel_title',
  PANEL_CONTENT: 'DesignPanel_EditTheme_remove_color_panel_body',
};
